var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 86,
    viewBox: "0 0 74 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_657_43753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4149 13.683L42.4826 0.630886C42.0759 0.223688 41.5252 -0.00322832 40.9523 3.47104e-05H6.46615C2.89495 3.47104e-05 0 2.92181 0 6.52609V63.0853C0 66.6896 2.89495 69.6113 6.46615 69.6113H49.5738C53.145 69.6113 56.04 66.6896 56.04 63.0853V15.2275C56.0434 14.6493 55.8184 14.0936 55.4149 13.683V13.683ZM51.7292 63.0853C51.7292 64.2867 50.7643 65.2606 49.5738 65.2606H6.46615C5.27571 65.2606 4.31077 64.2867 4.31077 63.0853V6.52609C4.31077 5.32462 5.27571 4.35074 6.46615 4.35074H38.7969V13.0521C38.7969 15.455 40.7269 17.4029 43.1077 17.4029H51.7292V63.0853V63.0853Z",
    fill: "#363ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4187 52.2085H43.1079V56.5592H47.4187V52.2085Z",
    fill: "#8D80E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4185 30.455H8.62158V34.8057H47.4185V30.455Z",
    fill: "#363ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4185 41.3318H8.62158V45.6825H47.4185V41.3318Z",
    fill: "#363ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.797 52.2085H8.62158V56.5592H38.797V52.2085Z",
    fill: "#363ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8859 86C64.099 86 73.9998 76.0075 73.9998 63.6812C73.9998 51.3549 64.099 41.3624 51.8859 41.3624C39.6727 41.3624 29.772 51.3549 29.772 63.6812C29.772 76.0075 39.6727 86 51.8859 86Z",
    fill: "#0BCB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8878 75.8546C51.2879 75.8546 50.7005 75.5561 50.3521 75.0088L40.0737 58.8631C39.5294 58.0082 39.7749 56.8698 40.6221 56.3204C41.4692 55.7711 42.5973 56.0189 43.1415 56.8739L53.42 73.0196C53.9642 73.8746 53.7187 75.013 52.8715 75.5624C52.5666 75.7601 52.2252 75.8546 51.8878 75.8546H51.8878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8842 75.8546C51.5468 75.8546 51.2054 75.7601 50.9005 75.5624C50.0532 75.013 49.8078 73.8746 50.352 73.0197L60.6305 56.8739C61.1748 56.019 62.3028 55.7713 63.1499 56.3204C63.9971 56.8698 64.2426 58.0082 63.6983 58.8632L53.4199 75.0089C53.0715 75.556 52.484 75.8546 51.8842 75.8546H51.8842Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_657_43753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadSuccess);
export default __webpack_public_path__ + "static/media/icon-upload-success.fefb8a7ff2c68bc47e79413a08019878.svg";
export { ForwardRef as ReactComponent };